import {
  anEntityInterface,
  anEntityTagOption,
  aTagSchema,
} from '__generated__';

import { mockEntityInputTagsQueryOperationQuery } from '@sbu/views.entityinputtags/build/mocks';

export const handlers = [
  mockEntityInputTagsQueryOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        entity: anEntityInterface(),
        entityTagOptions: [anEntityTagOption()],
        tagSchemas: [aTagSchema()],
      })
    );
  }),
];
